<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid ,reset}" ref="observer">
    <artisio-modal size="md" :visible="modal.show" :data="model" :title="$t(`Archive Temporary Items`)"
                   @show="onShow" @hidden="onHidden" @ok.prevent="handleSubmit(onSubmit)"
                   :show-confirmation="showConfirmation" :ok-title="$t('Submit')" :is-loading="loading"
                   scrollable>
      <div class="row">
        <div class="col-md-12">
          <input-widget :model="model" type='textarea' attribute="message"/>
        </div>
      </div>
    </artisio-modal>
  </ValidationObserver>
</template>

<script>
  import InputWidget from "../../../core/components/input-widget/InputWidget";
  import {createNamespacedHelpers} from "vuex";
  import ArtisioModal from "../../../core/components/artisio-modal/ArtisioModal";
  import ArchiveMessageModalModel from "@/modules/items/temporary/vuex/ArchiveMessageModal.model";

  const {mapState, mapActions} = createNamespacedHelpers('temporaryItems');

  export default {
    name: "ArchiveMessageModal",
    components: {
      InputWidget, ArtisioModal
    },
    data() {
      return {
        loading: false,
        showConfirmation: true,
        model: new ArchiveMessageModalModel(),
        errorMessage: null,
      }
    },
    computed: {
      ...mapState({
        modal: state => state.archiveMessageModal,
      }),
    },
    methods: {
      ...mapActions(['hideArchiveMessageModal', 'moveArchived']),
      onShow() {
        this.showConfirmation = true
      },
      onHidden() {
        this.model = new ArchiveMessageModalModel();
        this.hideArchiveMessageModal();
      },
      async onSubmit() {
        this.showConfirmation = false;
        let message = this.$i18n.t(
          "Are you sure you want to archive {count} temporary item(s) without message?",
          {count: this.modal.uuids.length}
        );

        if (this.model.message) {
          message = this.$i18n.t(
            "Are you sure you want to archive {count} temporary item(s) with message: `{message}`?",
            {count: this.modal.uuids.length, message: this.model.message}
          );
        }

        let success = await this.$confirm(message);
        if (success) {
          let response = await this.moveArchived({
            uuids: this.modal.uuids,
            archive: true,
            "message": this.model.message
          });
          if (response.success) {
            this.$toast('success', this.$i18n.t('Temporary item(s) were successfully archived'));
            this.hideArchiveMessageModal();
          } else {
            this.showConfirmation = true;
          }
        }
      },
    }
  }
</script>

<style scoped>

</style>
